const cookieExist = document.cookie.indexOf('TestAdagioABQA') > -1

export const isAbTesty = () => cookieExist
